import { Link } from "react-router-dom";
import { categories } from "@/mocks/resources";

export default function SiteIntro() {
  return (
    <section aria-label="网站简介" className="mt-12 md:mt-16 bg-background-100 border-y border-background-200">
      <div className="wrap py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium text-accent-700">
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-information-line text-base" aria-hidden="true"></i>
              </span>
              关于无码
            </p>
            <h2 className="mt-3 font-heading font-extrabold text-2xl md:text-3xl text-foreground-950 leading-tight">
              把高清资源的资讯整理清楚，
              <br className="hidden md:block" />
              让你少走弯路
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
              无码是一个以高清资源资讯为核心的内容门户。我们把影视、动漫、音乐三大分类的作品信息、版本动态与更新记录整理成易于浏览的结构，你可以按类型、地区、年份与标签快速筛选，也可以在详情页顺着标签找到风格接近的内容。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">
              站内所有作品、评分与访问量均为虚构演示数据，仅用于展示信息组织与浏览体验，不提供任何真实的下载或播放服务。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold cursor-pointer transition-colors whitespace-nowrap"
              >
                了解站点定位
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/search"
                className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 text-sm cursor-pointer transition-colors whitespace-nowrap"
              >
                <i className="ri-search-line" aria-hidden="true"></i>
                直接检索资源
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {categories.map((category) => (
              <div
                key={category.key}
                className="bg-background-50 border border-background-200 rounded-lg p-4 flex flex-col gap-2"
              >
                <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                  <i className={`${category.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="font-heading font-bold text-sm text-foreground-950">{category.label}分类</span>
                <span className="text-xs text-foreground-500 leading-5">{category.description}</span>
              </div>
            ))}
            <div className="sm:col-span-3 bg-background-50 border border-background-200 rounded-lg p-4 flex items-center justify-between gap-4 flex-wrap">
              <div>
                <p className="font-heading font-bold text-sm text-foreground-950">每日更新的版本动态</p>
                <p className="mt-1 text-xs text-foreground-500">修复版、完整版、幕后资讯一并整理</p>
              </div>
              <span className="chip bg-accent-100 text-accent-800">持续更新中</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}